import AlertDialog from "@/src/components/atom/AlertDialog";
import { useTranslation } from "react-i18next";

interface CancelAlertDialogProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOk: () => void;
}

function CancelAlertDialog({
  open,
  onOpenChange,
  onOk,
}: CancelAlertDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog
      open={open}
      title={t("cancelAlertDialog:title")}
      onOpenChange={onOpenChange}
      onOk={onOk}
      okText={t("cancelAlertDialog:okButton")}
      cancelText={t("cancelAlertDialog:cancelButton")}
    >
      {t("cancelAlertDialog:description")}
    </AlertDialog>
  );
}

export default CancelAlertDialog;
